import type { ReactNode } from 'react'

interface AuditorCycleTopBarProps {
  breadcrumb: ReactNode
  extra?: ReactNode
  actions?: ReactNode
  trailing?: ReactNode
}

export function AuditorCycleTopBar({
  breadcrumb,
  extra,
  actions,
  trailing,
}: AuditorCycleTopBarProps) {
  return (
    <div className='-ml-4 flex h-[50px] w-[calc(100%+16px)] items-center gap-2 px-5'>
      {breadcrumb}
      {extra}
      <div className='ml-auto flex flex-wrap items-center justify-end gap-2'>
        {actions}
        {trailing}
      </div>
    </div>
  )
}
